<template>
  <div class="ai-score-wrapper">
    <div v-if="scoring" class="ai-loading-container">
      <div class="ai-loading">
        <div class="ai-circle" />
        <div class="ai-circle" />
        <div class="ai-circle" />
        <div class="ai-pulse" />
      </div>
      <span class="ai-text">AI评分中...</span>
    </div>
    <a-popover placement="bottomLeft">
      <template slot="content">
        <div>触发AI评分，会自动更新任务的评分</div>
      </template>
      <a-button v-if="!scoring && (!aiScore || !aiScore.reason)" v-tc="{ name: 'AI评分' }" style="margin-right: 8px" @click="$emit('trigger')">AI评分</a-button>
    </a-popover>
    <a-popover v-if="aiScore && (aiScore.score || aiScore.score === 0) && !scoring" :visible="clicked" placement="bottomLeft" trigger="hover" @visibleChange="handleHoverChange">
      <template slot="content">
        <ai-score-view-detail style="width: 600px" :ai-score="aiScore" is-reset @reset="resetAiScore" />
      </template>
      <div v-if="aiScore && (aiScore.score || aiScore.score === 0) && !scoring" class="ai-score-tag" :class="getScoreClass(aiScore.score)">
        <a-icon type="robot" />
        <span>AI评分：{{ aiScore.score }}</span>
      </div>
    </a-popover>
  </div>
</template>

<script>
import AiScoreViewDetail from './AiScoreViewDetail.vue';

export default {
  name: 'AiScoreView',
  components: {
    AiScoreViewDetail
  },
  props: {
    scoring: {
      type: Boolean,
      default: false
    },
    aiScore: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      aiScoreTimeout: null,
      aiScoreInterval: null,
      clicked: false
    };
  },
  watch: {
    scoring(newVal) {
      if (newVal) {
        this.startAiScoreInterval();
      } else {
        this.clearAiScoreInterval();
      }
    }
  },
  mounted() {
    if (this.scoring) {
      this.startAiScoreInterval();
    }
  },
  beforeDestroy() {
    this.clearAiScoreInterval();
  },
  methods: {
    getScoreClass(score) {
      if (score >= 4) {
        return 'score-high';
      } else if (score >= 2) {
        return 'score-medium';
      } else {
        return 'score-low';
      }
    },
    startAiScoreInterval() {
      this.clearAiScoreInterval();
      this.aiScoreTimeout = setTimeout(() => {
        if (this.scoring) {
          this.$emit('scoring');
          this.aiScoreInterval = setInterval(() => {
            if (this.scoring) {
              this.$emit('scoring');
            } else {
              this.clearAiScoreInterval();
            }
          }, 15000);
        }
      }, 40000);
    },
    clearAiScoreInterval() {
      if (this.aiScoreTimeout) {
        clearTimeout(this.aiScoreTimeout);
        this.aiScoreTimeout = null;
      }
      if (this.aiScoreInterval) {
        clearInterval(this.aiScoreInterval);
        this.aiScoreInterval = null;
      }
    },
    handleHoverChange(visible) {
      this.clicked = visible;
    },
    resetAiScore() {
      this.clicked = false;
      this.$emit('trigger');
    }
  }
};
</script>

<style lang="less" scoped>
.ai-score-wrapper {
  display: inline-flex;
  align-items: center;
}

.ai-loading-container {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 8px;
}

.ai-loading {
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.ai-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1.5px solid transparent;
  border-top-color: #1890ff;
  border-radius: 50%;
  animation: ai-spin 1.5s linear infinite;

  &:nth-child(2) {
    border-top-color: #52c41a;
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    border-top-color: #722ed1;
    animation-delay: 1s;
  }
}

.ai-pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4px;
  height: 4px;
  background: #1890ff;
  border-radius: 50%;
  animation: ai-pulse 1.5s ease-in-out infinite;
}

.ai-text {
  color: #1890ff;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(90deg, #1890ff, #52c41a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ai-text-shine 2s linear infinite;
}

.ai-score-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;

  .anticon {
    margin-right: 4px;
  }

  &.score-high {
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
  }

  &.score-medium {
    background: #fff7e6;
    color: #fa8c16;
    border: 1px solid #ffd591;
  }

  &.score-low {
    background: #fff1f0;
    color: #f5222d;
    border: 1px solid #ffa39e;
  }
}

@keyframes ai-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes ai-pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0.5;
  }
}

@keyframes ai-text-shine {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
